"use strict";
angular.module('newspaperManageRouterModule', []).config(['$stateProvider', function($stateProvider) {
    $stateProvider.state("manageconfig.productmanage.newspaper.newspaperOrder", {
        url: '/newspaperOrder?paper',
        views: {
            'main@manageconfig.productmanage': {
                templateUrl: './manageConfig/productManageMent/newspaper/newspaperOrder/newspaperOrder_tpl.html',
                controller: 'newspaperOrderCtrl'
            }
        }
    }).state("manageconfig.productmanage.newspaper.editlayout", {
        url: '/editlayout?paper',
        views: {
            'main@manageconfig.productmanage': {
                templateUrl: './manageConfig/productManageMent/newspaper/editLayoutManage/editLayoutManage_tpl.html',
                controller: 'newsEditLayoutManageCtrl'
            }
        }
    }).state("manageconfig.productmanage.newspaper.typesettingpage", {
        url: '/typesettingpagepage?paper',
        views: {
            'main@manageconfig.productmanage': {
                templateUrl: './manageConfig/productManageMent/newspaper/typesettingPageManage/typesettingPageManage_tpl.html',
                controller: 'typesettingpagePageManageCtrl'
            }
        }
    }).state("manageconfig.productmanage.newspaper.typeclassifysettingpage", {
        url: '/typeclassifysettingpage?paper',
        views: {
            'main@manageconfig.productmanage': {
                templateUrl: './manageConfig/productManageMent/newspaper/typeClassifySettingPageManage/typeClassifySettingPageManage_tpl.html',
                controller: 'typeClassifySettingPageManageCtrl'
            }
        }
    }).state("manageconfig.productmanage.newspaper.distributeconfig", {
        url: '/distributeconfig?paper',
        views: {
            'main@manageconfig.productmanage': {
                templateUrl: './manageConfig/productManageMent/newspaper/distributeConfig/distributeConfig_tpl.html',
                controller: 'trsferNewsPaperDistributeConfigCtrl'
            }
        }
    }).state("manageconfig.productmanage.newspaper.default", { //中间跳转页
        url: "/default?paper",
        views: {
            'main@manageconfig.productmanage': {
                templateUrl: './manageConfig/productManageMent/newspaper/defaultPage/defaultPage_tpl.html',
                controller: ''
            }
        }
    });
}]);
